import { Drawer, Button, message } from "antd";
import { useState } from "react";
import { createEntrega } from "../../../../services/financiero/finEntregasService";
import EntregasBulkForm from "./EntregasBulkForm";

export default function EntregasModal({ open, onClose, participantes = [], productos = [], municipios = [], departamentos = [], proyectos = [], userLogin, reload }) {

  const [rows, setRows] = useState([]);
  const [validation, setValidation] = useState({ isValid: false });
  const [saving, setSaving] = useState(false);
  const handleSave = async () => {
    if (!validation.isValid) {
      message.warning("Hay errores en el formulario");
      return;
    }
    if (!rows.length) {
      message.warning("Debe agregar al menos una entrega");
      return;
    }
    try {
      setSaving(true);
      const payload = rows.map(r => ({
        ...r,
        usuario: userLogin,
        fecha_entrega: r.fecha_entrega?.format("YYYY-MM-DD")
      }));
      await Promise.all(
        payload.map(item => createEntrega(item))
      );
      message.success("Entregas registradas correctamente");
      reload();
      onClose();
    } catch (error) {
      console.error(error);
      message.error("Error guardando entregas");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Drawer
      title="Registrar múltiples entregas"
      open={open}
      onClose={onClose}
      width={1200}
      destroyOnClose
      extra={
        <Button
          type="primary"
          loading={saving}
          onClick={handleSave}
        >
          Guardar entregas
        </Button>
      }
    >
      <EntregasBulkForm
        participantes={participantes}
        productos={productos}
        municipios={municipios}
        departamentos={departamentos}
        proyectos={proyectos}
        onChange={setRows}
        onValidationChange={setValidation}
      />
    </Drawer>
  );
}